var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84629 0.570612L8.51123 0H6.48359V5.13923L6.47668 10.1591C6.48014 10.1964 6.48359 10.2374 6.48359 10.2747C6.48359 11.5316 5.53713 12.5572 4.3696 12.5572C3.20207 12.5572 2.25561 11.5353 2.25561 10.2747C2.25561 9.0179 3.20207 7.99229 4.3696 7.99229C4.6114 7.99229 4.84629 8.04078 5.0639 8.12282V5.61661C4.83938 5.57558 4.60794 5.55321 4.3696 5.55321C1.962 5.55694 0 7.67529 0 10.2785C0 12.8817 1.962 15 4.37306 15C6.78411 15 8.74611 12.8817 8.74611 10.2785V4.30756C9.62003 5.25112 10.7496 6.1723 12 6.46693V3.90477C10.6425 3.25584 9.29188 1.33889 8.84629 0.570612Z",
    fill: "#EE2D2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.ab6bd4cf.svg";
export { ForwardRef as ReactComponent };